<sim-assessable-group-panel [type]="AssessablePanelType.Assessment" [scoreTemplate]="groupScoreTemplate">
	<ng-template #groupScoreTemplate let-data>
		@if (!hideScore() && store.mode() !== AssessablePanelMode.Answer) {
			<mat-divider [vertical]="true" />

			<div class="scoreInHeader">
				<div class="reachedScore">
					{{ getGroupScore(data.groupId) }}
				</div>
				/
				<div class="maxScore">
					{{ getMaxGroupScore(data.groupId) }}
				</div>
			</div>

			<mat-divider [vertical]="true" />
		}
	</ng-template>

	<ng-template assessableItemTemplate [assessable]="assessable()" let-data>
		<sim-assessment-item
			[data]="data"
			[hideScore]="hideScore()"
			[isInArchive]="isInArchive()"
			(onTimestampClicked)="onJumpToItem.emit(data.item.answerTime)"
		/>
	</ng-template>
</sim-assessable-group-panel>
